import { useState, useContext } from "react"
import { useQuery } from "@apollo/client"
import _ from "lodash"
// Context
import { UserContext } from "../../context/userContext"

// Queries
import { PARTICIPANT_BLOCK } from "./queries"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"

// Helpers
import FieldValuePerType from "./FieldValuePerType"

import PropTypes from "prop-types"

import styles from "../../styles/Participant-Profile.module.css"

// Define which field types should be skipped
const skipFieldTypes = {
  hidden: true,
  sys: true,
}

// Define which field names should be processed regardless of their type
const skipFieldNames = {
  demo_ssn: true,
}

export default function ParticipantProfileBlocks(props) {
  const [formValues, setFormValues] = useState({})
  const userCtx = useContext(UserContext)
  const PID = userCtx.current_participant_id || "not-set"
  const TYPE = "auto"
  const variables = {
    participant_id: PID,
    idBlock: props.idBlock,
    type: TYPE,
    organization_id: userCtx.session.user.organization_id,
    enterprise_id: userCtx.session.user.enterprise_id,
  }

  const { loading, data } = useQuery(PARTICIPANT_BLOCK, {
    variables,
    fetchPolicy: "cache-first", // This exact query is already run on the parent component, therefore we can use cache-first
    skip: !userCtx.session.user.staff_id,
    onCompleted: (data) => {
      try {
        const parsedFormValues = JSON.parse(data.blockSaved.data) || {}
        const filterEmptyValues = _.reduce(
          parsedFormValues.values,
          (acc, value, key) => {
            return {
              ...acc,
              [key]: value,
            }
          },
          {}
        )
        setFormValues(filterEmptyValues)
      } catch (error) {}
    },
  })

  const handleFields = () => {
    const fields = data.block.fields
    if (fields) {
      return _.map(
        fields,
        ({
          field_label,
          field_name,
          field_type,
          field_type_subtype,
          field_options,
          field_description,
        }) => {
          const skipField =
            skipFieldTypes[field_type] && !skipFieldNames[field_name]
          if (skipField) return null
          const fieldValuePerTypeArg = {
            blockValues: formValues,
            fieldName: field_name,
            fieldType: field_type,
            fieldSubtype: field_type_subtype,
            fieldOptions: field_options,
            description: field_description,
          }
          const preferencesTemplate = ({
            participant_important_contact_preference,
          }) => {
            if (Array.isArray(participant_important_contact_preference)) {
              return (
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      participant_important_contact_preference.join("<br>"),
                  }}
                />
              )
            }
            return participant_important_contact_preference || "N/A"
          }

          const handleLabel = () => {
            if (field_type === "file") {
              return "File"
            }
            return field_label
          }
          const fieldValue = fieldValuePerTypeArg.blockValues[field_name]
          if (
            fieldValue &&
            (Array.isArray(fieldValue) ? fieldValue.length > 0 : true)
          ) {
            try {
              switch (field_name) {
                case "participant_important_contacts":
                  if (
                    !_.isNull(
                      fieldValuePerTypeArg.blockValues
                        .participant_important_contacts
                    ) &&
                    Array.isArray(
                      fieldValuePerTypeArg.blockValues
                        .participant_important_contacts
                    )
                  ) {
                    return (
                      <div
                        className="view-table"
                        style={{ maxWidth: "1600px" }}
                        key={field_name}
                      >
                        <div className={styles.customSpacedHr} />

                        <h2 className="profile-title">
                          Important participant contacts
                        </h2>
                        <DataTable
                          value={
                            fieldValuePerTypeArg.blockValues
                              .participant_important_contacts
                          }
                          responsiveLayout="scroll"
                          sortField="participant_important_contact_name"
                          sortOrder={1}
                        >
                          <Column
                            field="participant_important_contact_name"
                            header="Name"
                          />
                          <Column
                            field="participant_important_contact_type"
                            header="Type of Contact"
                          />
                          <Column
                            field="participant_important_contact_phone"
                            header="Phone Number"
                          />
                          <Column
                            field="participant_important_contact_preference"
                            header="Contact Type Preferences"
                            body={preferencesTemplate}
                          />
                          <Column
                            field="participant_important_contact_email"
                            header="Email"
                          />
                        </DataTable>
                      </div>
                    )
                  } else {
                    return ""
                  }

                default:
                  return (
                    <div
                      id={field_name}
                      key={field_name}
                      className="view-data-field"
                    >
                      <div className="field-name">
                        <strong>{handleLabel()}</strong>
                      </div>
                      <div className="field-value">
                        <FieldValuePerType
                          fieldValuePerTypeArg={fieldValuePerTypeArg}
                        />
                      </div>
                    </div>
                  )
              }
            } catch (error) {
              console.error(error)
            }
          }
        }
      )
    }
    return ""
  }

  if (loading) return <div>Loading...</div>

  return (
    <div
      className="layout-with-sidebar2 view-mode profile-tabs"
      id="top-view-form"
    >
      <div className="sidebar2"></div>

      <div className="main-content2 asd">
        <div>
          <div className={styles.customSpacedHr} />

          <div>{handleFields()}</div>
          {handleFields().every(_.isNull) ? "No data available" : ""}
        </div>
      </div>
    </div>
  )
}

ParticipantProfileBlocks.propTypes = {
  idBlock: PropTypes.string.isRequired,
}
